import React, { useCallback } from 'react';
import type { VirtualGridOverlayApiT } from '../../../../common/virtual-grid';
import { VirtualGrid } from '../../../../common/virtual-grid';
import { LABEL_COLUMN_WIDTH, RULER_EDGE_PADDING, RULER_HEADER_HEIGHT } from '../../constants/frame-timeline-v4';
import { useSpanResizeController } from '../../hooks/use-span-resize-controller';
import type { TimelineActionsT, TimelineRowDescriptorT } from '../../types/frame-timeline-v4';
import { RowLabel } from './row-label';
import { TimelineCell } from './timeline-cell';
import { TimelineCorner } from './timeline-corner';
import { TimelineOverlay } from './timeline-overlay';
import { RulerTick } from './timeline-ruler';
export type TimelineGridPropsT = {
  totalFrames: number;
  cellWidth: number;
  rowHeight: number;
  objectsTitle: string;
  rows: TimelineRowDescriptorT[];
  timelineActions?: TimelineActionsT;
};
export const TimelineGrid = ({
  totalFrames,
  cellWidth,
  rowHeight,
  objectsTitle,
  rows,
  timelineActions
}: TimelineGridPropsT) => {
  useSpanResizeController(totalFrames);
  const renderOverlay = useCallback((overlayControls: VirtualGridOverlayApiT) => <TimelineOverlay totalFrames={totalFrames} cellWidth={cellWidth} overlayControls={overlayControls} />, [totalFrames, cellWidth]);
  return <VirtualGrid renderOverlay={renderOverlay} column={{
    // One extra column: column 0 is the empty "0f" origin and spans are shifted one
    // column right, so the last frame's bar (column totalFrames) isn't clipped.
    count: totalFrames + 1,
    itemSize: cellWidth,
    headerSize: RULER_HEADER_HEIGHT,
    renderHeader: frame => <RulerTick frame={frame} />,
    paddingStart: RULER_EDGE_PADDING,
    paddingEnd: RULER_EDGE_PADDING
  }} row={{
    count: rows.length,
    itemSize: rowHeight,
    headerSize: LABEL_COLUMN_WIDTH,
    getKey: index => rows[index]?.id ?? index,
    renderHeader: index => {
      const descriptor = rows[index];
      return descriptor ? <RowLabel descriptor={descriptor} timelineActions={timelineActions} /> : null;
    }
  }} renderCorner={() => <TimelineCorner title={objectsTitle} />} renderCell={(rowIndex, columnIndex) => {
    const row = rows[rowIndex];
    if (!row) {
      return null;
    }
    return <TimelineCell row={row} frame={columnIndex} timelineActions={timelineActions} cellWidth={cellWidth} />;
  }} />;
};